var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9 22.468H10.15C9.87152 22.468 9.60445 22.5786 9.40754 22.7755C9.21062 22.9724 9.1 23.2395 9.1 23.518C9.1 23.7964 9.21062 24.0635 9.40754 24.2604C9.60445 24.4573 9.87152 24.568 10.15 24.568H25.9V26.668H10.15C9.31457 26.668 8.51335 26.3361 7.92261 25.7454C7.33187 25.1546 7 24.3534 7 23.518V7.76797C7 7.21101 7.22125 6.67687 7.61508 6.28304C8.0089 5.88922 8.54305 5.66797 9.1 5.66797H25.9V22.468ZM9.1 20.4205C9.2701 20.3858 9.44545 20.368 9.625 20.368H23.8V7.76797H9.1V20.4205ZM20.65 13.018H12.25V10.918H20.65V13.018Z",
    fill: "#868A95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingsIcon);
export default __webpack_public_path__ + "static/media/bookings-icon.ab2f7f8c2febf9aa28ab0d5806190506.svg";
export { ForwardRef as ReactComponent };